import React from 'react';
import { Badge } from '@/components/ui/badge'

const DiscountLabel = (props) => {
  return (
    <span className="mt-px inline-block text-center align-top">
      <Badge variant="destructive" className="font-bold">{props.discount_percent}%</Badge>
      <small className="ml-1 text-[13px] font-bold text-destructive">Discount</small>
    </span>
  );
}

export default DiscountLabel;
